// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from 'react-helmet';
import { useTranslation } from "react-i18next";
import he from "he";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID, appConfig } from "../../config/appConfig";

// COMPONENTI
import SubHeaderHome from "../Header/subHeader/SubHeaderHome";
import PropertySearchField from "./Search";
import ServicesSection from "./ServicesSection";
import Vetrina1 from "./Vetrina1";
import Vetrina2 from "./Vetrina2";
import FooterBannerVendi from "./FooterBannerVendi";
import LocationSearch from "./LocationSearch";
import Presentation from "./Presentation";
import SocialPost from "./SocialPost";
import GoogleReviews from '../Reviews/GoogleReviews';
import HomeValuation from "./HomeValuation/HomeValuation";
import BannerVendi from "./BannerVendi";
import TipologySearchSection from "./TipologySearchSection";
import LastProperties from "./LastProperties";

interface Props {
  seo: boolean;
  vetrina2: boolean;
  pageType: string;
  filters: { [key: string]: string[] };
  showLocationSearch: boolean;
  showFooterBannerVendi: boolean;
  showPresentationSection: boolean;
  showSocialSection: boolean;
  showVetrina1: boolean;
}

const HomePage: React.FC<Props> = ({
  seo,
  vetrina2,
  pageType,
  showLocationSearch,
  showFooterBannerVendi,
  showPresentationSection,
  showSocialSection,
  showVetrina1
}) => {

  const { t } = useTranslation();
  const { agency } = useGetAgencyDetails(AGENCY_ID);

  // --- Lettura Flag Indipendenti dalla Configurazione ---
  const shouldShowInSubHeader = appConfig.ui.searchForm.showSearchInHomePageSubHeader;
  const shouldShowBelowIntro = appConfig.ui.searchForm.showSearchBelowHomePageIntro;
  const shouldShowSearchAndFiltersSection = appConfig.ui.homePage.showSearchAndFilters;
  const homeValuationConfig = appConfig.features.homeValuation;
  // --- Fine Lettura ---

  const isSeo = pageType === 'home';

  return (
    <>
      <Helmet>
        <title>{he.decode(`${agency?.agencyName}`) ?? t('common.loading')}</title>
      </Helmet>

      <SubHeaderHome
        isSeo={isSeo}
        showSearchForm={shouldShowInSubHeader}
      />

      {shouldShowSearchAndFiltersSection && pageType === 'home' &&
        <section id="search-box"className="space-ptb position-relative">
          <div className="container-fluid">
            <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.searchForm.title') as string }} />
            <div className="row">
              <div className="col-12">
                {shouldShowBelowIntro && <PropertySearchField searchData={{}} />}
              </div>
            </div>
          </div>
        </section>
      }

      {/* Vetrina con immobili */}
      {vetrina2 && <Vetrina2 agencyName={agency?.agencyName ?? ''} />}

      {/* Ultimi aggiunti */}
      {<LastProperties />}

      {showPresentationSection && (
        <Presentation />)
      }

      {/* Ricerca per tiologia */}
      <TipologySearchSection />

      {/* Banner Valuta */}
      <BannerVendi /> 

      {/* Anteprima servizi */}
      {appConfig.ui.homePage.showServices && (
        <ServicesSection />
      )}

      {/* Footer Banner Vendi */}
      {showFooterBannerVendi && <FooterBannerVendi />}

      {/* Vetrina con immobili */}
      {showVetrina1 && <Vetrina1 />}

      {/* Sezione Google Reviews */}
      {appConfig.features.googleReviews.enabled && (
        <section className="space-ptb bg-gray">
          <div className="container">
            <GoogleReviews />
          </div>
        </section>
      )}

      {homeValuationConfig.enabled && homeValuationConfig.displayMode === 'banner' && (
        <section className="space-ptb bg-light">
          <div className="container">
            <HomeValuation />
          </div>
        </section>
      )}

      {/* Ricerca veloce con immagini */}
      {showLocationSearch && <LocationSearch seo={seo} />}

      {/* Social section */}
      {showSocialSection && <SocialPost />}
    </>
  );
};

export default HomePage;